import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow, RadioButton } from "@similarweb/ui-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledAppCategoryFilterResult = styled(FlexRow)`
    flex-wrap: wrap;
`;

export const StyledRadioButtonContainer = styled(FlexRow)`
    margin-bottom: 16px;
`;

export const StyledDropdownContainer = styled(FlexColumn)`
    display: flex;
    gap: 8px;
    width: 263px;

    & .DropdownButton {
        & .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }
`;

export const StyledRadioButton = styled(RadioButton)`
    padding: 0 20px 9px 0;
    &:last-child {
        padding-right: 0;
    }

    label {
        margin-left: 4px;
    }
`;

export const StyledDropdownLabel = styled.div`
    display: flex;
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
`;
